import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PersonRegistrationResource, PersonVisitForm } from 'src/app/models/iregistration.interface';
import { GLOBAL_CONVERTERS } from '../../global.converters';
import { RegService } from 'src/app/services/data/reg.service';
import { ConfirmationService } from 'primeng/api';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize, tap } from 'rxjs/operators';
import { IError } from 'src/app/models/ierror.interface';
import { MessageToastService } from 'src/app/services/common/message-toast.service';

@UntilDestroy()
@Component({
  selector: 'app-person-conference-visit-view',
  templateUrl: './person-conference-visit-view.component.html',
  styleUrls: ['./person-conference-visit-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonConferenceVisitViewComponent implements OnInit {
  @Input() data: PersonRegistrationResource;
  @Input() isReadOnly: boolean = true;
  @Output() edit = new EventEmitter<PersonVisitForm>();
  // @Output() printInvite = new EventEmitter();
  // @Output() sendInvite = new EventEmitter();


  constructor(
    private _reg: RegService,
    private _msg: MessageToastService,
    private _confirm: ConfirmationService,
  ) { }

  ngOnInit(): void {
  }

  onEdit() {
    const form = {
      rankId: this.data.rankId,
      companyId: this.data.companyId,
      isBadgePrinted: this.data.isBadgePrinted,
      isArrive: this.data.isArrive,
      isNeedBadge: this.data.isNeedBadge,
      dateArrive: this.data.dateArrive || GLOBAL_CONVERTERS.getStringFromDateTime(new Date()),
      dateRegister: this.data.dateRegister || GLOBAL_CONVERTERS.getStringFromDateTime(new Date())
    } as PersonVisitForm;
    this.edit.emit(form);
  }

  onPrintInvitation() {
    this._reg.pdfInvitation(this.data.id).pipe(
      untilDestroyed(this),
      tap((res) => {
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
      }),
    ).subscribe();
  }
  onSendInvitation() {
    this._confirm.confirm({
      message: `Вы действительно хотите отправить приглашение на конференцию?`,
      accept: () => {
        this._reg.sendInvitation(this.data.id).pipe(
          untilDestroyed(this),
          tap((res: IError) => {
            this._msg.success(res.message);
          }),
        ).subscribe();
      },
      reject: () => { }
    });
  }



}
